import { render, staticRenderFns } from "./AddDirect.vue?vue&type=template&id=3dcba8f7&scoped=true&"
import script from "./AddDirect.vue?vue&type=script&lang=js&"
export * from "./AddDirect.vue?vue&type=script&lang=js&"
import style0 from "./AddDirect.vue?vue&type=style&index=0&id=3dcba8f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcba8f7",
  null
  
)

export default component.exports